<template>
	<div class="homework-row">
		<label>
			{{ 'Game type' | translate }}
			<select v-model="config.type" class="form-control">
				<option :value="type.value" v-for="(type, index) in gameTypes" :key="index">
					{{ type.label | translate }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Level' | translate }}
			<select required v-model="config.options.type" class="form-control">
				<option :value="digit.value" v-for="(digit, index) in additionType" :key="index">
					{{ $t(digit.label).toLowerCase() }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Calculation method' | translate }}
			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="oral" />
					{{ 'Imaginary abacus' | translate }}
				</label>
			</div>

			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="abacus" />
					{{ 'Abacus' | translate }}
				</label>
			</div>
		</label>

		<label v-if="!isAnzan && !isTransition">
			{{ 'Digit' | translate }}
			<select required v-model="config.options.digit" class="form-control">
				<option :value="number" v-for="(number, index) in digits" :key="index">
					{{ number }}
				</option>
			</select>

		</label>

		<div class="pro-box" v-if="!isAnzan && !isTransition && isProDigits">
			<p>Pro</p>

			<input type="checkbox" @change="switchProMode" :checked="config.options.option === 'pro'" />
		</div>

		<label v-if="isAnzan">
			{{ 'Anzan' | translate }} type
			<select required v-model="config.options.digit_type" class="form-control">
				<option :value="digit.value" v-for="(digit, index) in anzanType" :key="index">
					{{ $t(digit.label).toLowerCase() }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Complexity' | translate }}
			<select required v-model="config.options.places" class="form-control">
				<option :value="difficult" v-for="(difficult, index) in difficult" :key="index">
					{{ difficult }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Speed' | translate }}
			<input required type="number" step="0.1" max="10" min="0.1" v-model="config.options.speed" @blur="onBlurSpeed"
				class="form-control" />
		</label>

		<label>
			{{ 'Action with numbers' | translate }}
			<input required type="number" min="1" step="1" max="25" v-model="config.options.length" @blur="onBlurLength"
				class="form-control" />
		</label>

		<label>
			{{ 'Number of expressions' | translate }}
			<input type="number" :value="config.repeat" @input="onInputRepeat" @blur="onBlurRepeat" min="1" max="10" step="1"
				class="form-control" />
		</label>
	</div>
</template>

<script>
import { DEFAULT_ADDITION_OPTIONS } from '../Create.vue'
import {
	LABELED_ADDITION_TYPES,
	PLACES,
	getAdditionalDigits,
	getAdditionalProDigits,
} from '../../../Games/gameConfig'
import TransactionsHistory from '@/containers/Modals/TransactionsHistory.vue'

export default {
	name: 'addition',
	props: {
		config: Object,
		onInputRepeat: Function,
		onBlurRepeat: Function,
		gameTypes: Array,
	},
	// created() {
	// 	if (this.config.id || this.config.is_created) {
	// 		this.config.id = undefined

	// 		if (
	// 			// !this.config.options.digit

	// 			!this.config.options.places
	// 			|| !this.config.options.type
	// 			|| this.config.options.type == 'abacus_random_2'
	// 			|| this.config.options.type.includes("multiply")
	// 		) {
	// 			this.config.options = { ...DEFAULT_ADDITION_OPTIONS }
	// 		}
	// 	} else {
	// 		// small super-fast fix for make new config object
	// 		this.config.options = { ...DEFAULT_ADDITION_OPTIONS }
	// 	}

	// 	this.config.is_created = true

	// 	// if (this.config.id) {
	// 	// 	this.config.id = undefined
	// 	// } else {
	// 	// 	this.config.options = { ...DEFAULT_ADDITION_OPTIONS }
	// 	// }
	// },
	methods: {
		switchProMode() {
			this.config.options.option = this.config.options.option == 'pro' ? '' : 'pro'
		},
		// onChangeLength({ target }) {
		// 	const {
		// 		value,
		// 		validity: { valid },
		// 	} = target
		// 	this.config.options.length =
		// 		value && !valid ? this.config.options.length : value
		// 	target.value = this.config.options.length
		// },
		onBlurLength() {
			if (
				!this.config.options.length ||
				Number(this.config.options.length <= 2)
			) {
				this.config.options.length = 2
			}
		},
		// onChangeSpeed({ target }) {
		// 	const {
		// 		value,
		// 		validity: { valid },
		// 	} = target
		// 	this.config.options.speed =
		// 		value && !valid ? this.config.options.speed : value
		// 	target.value = this.config.options.speed
		// },
		onBlurSpeed() {
			if (
				!this.config.options.speed ||
				Number(this.config.options.speed <= 0.1)
			) {
				this.config.options.speed = 0.1
			}
		},
	},
	watch: {
		'config.options.length'() {
			if (this.config.options.length > 25) {
				this.config.options.length = 25
			}
		},

		'config.options.places'() {
			const firstDigit = this.digits[0]
			if (
				this.config.options.type === 'elementary' &&
				+this.config.options.places === 1 &&
				firstDigit > +this.config.options.digit
			) {
				this.config.options.digit = firstDigit.toString()
			}
		},

		'config.options.type'(value) {
			if (this.config.options.type == "fifty" && this.config.options.places < 10) {
				this.config.options.places = 10
			}

			if (this.config.options.type == "hundred" && this.config.options.places < 100) {
				this.config.options.places = 100
			}

			if (this.config.options.type == "anzan" && this.config.options.type == "fifty" && this.config.options.type == "hundred") {
				this.config.options.option = ''
			}

			if (this.config.options.type != "anzan") {
				delete this.config.options.digit_type
			}

			if (this.config.options.type == "anzan" && this.config.options.digit_type == undefined) {
				this.config.options.digit_type = 'anzan_random'
			}
		},

		isProDigits(value) {
			if (!value) {
				this.config.options.option = ''
			}
		}
	},
	computed: {
		isAnzan() {
			return this.config.options.type === 'anzan'
		},
		isTransition() {
			return this.config.options.type.includes('fifty') || this.config.options.type.includes('hundred')
		},
		anzanType() {
			return [
				{ value: 'anzan_random', label: 'Random numbers' },
				{ value: 'anzan_minus', label: 'Only subtraction' },
				{ value: 'anzan_plus', label: 'Only add' },
			]
		},
		additionType() {
			return LABELED_ADDITION_TYPES
		},
		difficult() {
			if (this.isTransition) {
				if (this.config.type.includes('hundred')) {
					return PLACES.filter(i => i !== 1 && i !== 10)
				}

				return PLACES.filter(i => i !== 1)
			};

			return PLACES
		},

		digits() {
			const { type, places } = this.config.options

			return getAdditionalDigits(type, +places)
		},

		isProDigits() {
			const { type, places, digit } = this.config.options

			return getAdditionalProDigits(type, +places).includes(Number(digit))
		},
	},
}
</script>

<style lang="scss" scoped>
.pro-box {
	margin-right: 30px;
}
</style>
